import React, { useState } from 'react'
import { useNavigationContext } from '#src/components/Header/StandardHeader/NavigationContext'
import { useDepartmentContext } from '#src/context/department'
import BrowseMenu from '../BrowseMenu'
import ExploreIcon from '#src/components/Header/StandardHeader/icons/mobile/explore.svg'
import SearchIcon from '#src/components/Header/StandardHeader/icons/mobile/search.svg'
import styles from './styles.css'

const GlobalNavgiation: React.FC = () => {
  const departmentContext = useDepartmentContext()
  const navContext = useNavigationContext()

  const [isBrowseExpanded, setIsBrowseExpanded] = useState(false)

  return (
    <>
      <div className={styles.navGroup}>
        <button
          onClick={() => {
            setIsBrowseExpanded(true)

            // Notify the global nav context that the browse menu is hidden
            navContext?.onToggleIsMobileBrowseMenuVisible(true)
          }}
          className={styles.browseNavItem}
          data-testid="mobile-browse-menu-trigger"
        >
          <ExploreIcon className={styles.exploreIcon} />
        </button>
        {departmentContext.department && (
          <button
            className={styles.searchNavItem}
            onClick={() => {
              navContext?.onToggleIsSearchVisible(true)
            }}
            data-testid="mobile-search-menu-trigger"
          >
            <SearchIcon className={styles.searchIcon} />
          </button>
        )}
      </div>

      <BrowseMenu
        isBrowseExpanded={isBrowseExpanded}
        onClose={() => {
          setIsBrowseExpanded(false)

          // Notify the global nav context that the browse menu is hidden
          navContext?.onToggleIsMobileBrowseMenuVisible(false)

          // Wipe the department ID to reset the menu
          navContext?.onSetActiveDepartmentSlug(null)
        }}
      />
    </>
  )
}

export default GlobalNavgiation
